/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsDeploymentCommerce } from './vcdsDeploymentCommerce';


export interface VcdsDeploymentPatchSpec { 
    /**
     * Org Id
     */
    org_id: string;
    state?: VcdsDeploymentStateEnum;
    tasks?: Array<string>;
    commerce?: VcdsDeploymentCommerce;
}
export namespace VcdsDeploymentPatchSpec {
}


